<template>
  <div>
    <title>采购录入</title>
    <section class="mainDet">
        <!--S 基本信息表单-->
        <el-form :model="checkForm" ref="ruleForm" label-width="100px" class="comForm" :rules="checkRule">
            <el-row class="mainWrap">
                <el-col :span="24">
                    <div class="grid-content">
                        <p class="commonTit"><b>采购录入</b></p>
                        <el-form-item label="销售方" prop="salercode">
                            <BuyerAndSellerSelecr :saleInfo="checkForm" :roleType="1" @invoiceObtain="invoiceObtain" v-if="saleShow"></BuyerAndSellerSelecr>
                        </el-form-item>
                        <el-form-item label="供应商名称" prop="supplyername">
                            <el-input v-model="checkForm.supplyername" maxlength="30" clearable placeholder="请输入供应商名称"></el-input>
                        </el-form-item>
                        <el-form-item label="采购说明">
                            <el-input type="textarea" v-model="checkForm.memo" placeholder="请输入内容" clearable maxlength="60" show-word-limit></el-input>
                        </el-form-item>
                    </div>
                    <el-button type="primary" @click="getShowDlog('add')">追加录入采购商品</el-button>
                </el-col>
                
                <el-col :span="24" class="pt30">
                    <div class="grid-content" id="selGoodsList">
                        <el-table class="comTable orderTable" ref="gsTable" :data="payRecordList" :key="keys" border maxHeight="650">
                            <el-table-column label="序号" type="index"></el-table-column>
                            <!-- <el-table-column label="供应商名称" min-width="200">
                                <template slot-scope="scope">
                                <p class="textFl pdr70" :title="scope.row.supplyername">{{scope.row.supplyername}}</p>
                                </template>
                            </el-table-column> -->
                            <el-table-column label="产品名称" min-width="200">
                                <template slot-scope="scope">
                                <p class="textFl pdr70" :title="scope.row.invgoodsname">{{scope.row.invgoodsname}}</p>
                                </template>
                            </el-table-column>
                            <el-table-column label="规格型号"  min-width="200">
                                <template slot-scope="scope">
                                    <p class="textFl pdr70" :title="scope.row.invkindinfo">{{scope.row.invkindinfo}}</p>
                                </template>
                            </el-table-column>
                            <el-table-column label="单位" min-width="100" sortable prop="unit">
                                <template slot-scope="scope">
                                    <p>{{scope.row.unit}}</p>
                                </template>
                            </el-table-column>
                            <el-table-column label="单价(￥)" min-width="100" sortable prop="unitprice">
                                <template slot-scope="scope">
                                    <p>{{scope.row.unitprice}}</p>
                                </template>
                            </el-table-column>
                            <el-table-column label="税率(%)" min-width="100" sortable prop="taxrate">
                                <template slot-scope="scope">
                                <p>{{scope.row.taxrate}}</p>
                                </template>
                            </el-table-column>
                            <el-table-column label="数量" min-width="100" sortable prop="num">
                                <template slot-scope="scope">
                                    <p>{{scope.row.num}}</p>
                                </template>
                            </el-table-column>
                            <!-- <el-table-column label="状态" sortable prop="status" width="120">
                                <template slot-scope="scope">
                                    <el-switch v-model="scope.row.status" disabled :width="45" class="isSwitch" :active-text="scope.row.status?'启':'禁'"></el-switch>
                                </template>
                            </el-table-column> -->
                            <el-table-column label="备注"  min-width="200">
                                <template slot-scope="scope">
                                    <p class="textFl pdr70" :title="scope.row.memo">{{scope.row.memo}}</p>
                                </template>
                            </el-table-column>
                            <el-table-column label="操作" width="120" fixed="right">
                                <template slot-scope="scope">
                                    <p class="handle">
                                    <span class="detailA" title="编辑" @click="getShowDlog('edit',scope.row,scope.$index)"><i class="iconedit"></i></span>
                                    <span title="删除" slot="reference" @click="delDlog(scope.$index)"><i class="icondel"></i></span>
                                    </p>
                                </template>
                            </el-table-column>
                            <template slot="empty">
                                <div class="noData"><span>暂无数据</span></div>
                            </template>
                        </el-table>
                    </div>
                </el-col>
            </el-row>
        </el-form>
        <!--E 基本信息表单-->
        <div class="flexUpDownCenter bottomBtn">
            <em class="flexUpDownCenter isChose">本次采购总金额 
                <b class="priceFont redColor" v-if="!isEditMoney"><i>￥</i>{{totalAmount?totalAmount:0}}</b>
                <el-input v-model="totalAmount" v-if="isEditMoney" class="editMoneyIpt" clearable maxlength="9">
                    <template slot="prepend">￥</template>
                </el-input>
                <strong class="iconedit editIcon blueColor" @click="getEditMoney" v-if="!isEditMoney" title="编辑采购总金额"></strong>
                <b v-if="isEditMoney" class="editBtn">
                    <samp class="blueColor" @click="subEditMoney(1)">确定</samp>
                    <samp class="redColor" @click="subEditMoney(0)">取消</samp>
                </b>
            </em>
            <el-button type="primary" @click="procureSubmit">提交</el-button>
            <el-button @click="$router.back(-1)">返回列表</el-button>
        </div>
    </section>
    <!-- S 追加采购商品 -->
    <el-dialog class="comDlog addMemberDlog" :title="operate == 'add' ?'追加采购商品':'采购商品编辑'" :visible.sync="tradingRoleDlog" :before-close="getCloseDlog" append-to-body :close-on-click-modal="false">
        <el-form :model="tradingRoleForm" :rules="tradingRoleRule" ref="tradingRoleForm" label-width="140px">
            <el-row class="goodsWrap">
                <el-col :span="11">
                    <el-form-item label="产品名称" prop="invgoodsname">
                        <el-input v-model="tradingRoleForm.invgoodsname" maxlength="30" clearable placeholder="请输入产品名称" @blur="checkNames(0)"></el-input>
                    </el-form-item>
                    <el-form-item label="规格型号" prop="invkindinfo">
                        <el-input v-model="tradingRoleForm.invkindinfo" maxlength="40" clearable placeholder="请输入规格型号" @blur="checkNames(1)"></el-input>
                    </el-form-item>
                    <el-form-item label="单位" prop="unit">
                        <el-input v-model="tradingRoleForm.unit" clearable placeholder="请输入产品单位" maxlength="10" @blur="checkNames(2)"></el-input>
                    </el-form-item>
                    <el-form-item label="单价" prop="unitprice">
                        <el-input v-model="tradingRoleForm.unitprice" clearable placeholder="请输入单价" maxlength="9">
                            <template slot="prepend">￥</template>
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="2"></el-col>
                <el-col :span="11">
                    <el-form-item label="税率" prop="taxrate">
                        <el-input v-model="tradingRoleForm.taxrate" maxlength="3" clearable placeholder="请输入税率">
                            <template slot="append">%</template>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="数量" prop="num">
                        <el-input v-model="tradingRoleForm.num" maxlength="9" clearable placeholder="请输入数量">
                            <template slot="append" v-if="tradingRoleForm.unit">{{tradingRoleForm.unit}}</template>
                        </el-input>
                    </el-form-item>
                    <!-- <el-form-item label="状态">
                        <el-switch v-model="tradingRoleForm.status" :width="45" class="isSwitch" :active-text="tradingRoleForm.status?'启':'禁'"></el-switch>
                    </el-form-item> -->
                    <el-form-item label="备注">
                        <el-input type="textarea" v-model="tradingRoleForm.memo" placeholder="请输入备注" clearable maxlength="100" show-word-limit></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="getCloseDlog(1)">确定</el-button>
            <el-button @click="getCloseDlog">取消</el-button>
        </span>
    </el-dialog>
    <!-- E 追加采购商品 -->
  </div>
</template>
<script>
import { MessageBox } from "element-ui";
import Vue from "vue";
import api from '@/apis/api.js';
export default {
    name: 'PurchaseAdd',
    data () {
        return {
           keys:0,
            checkForm:{
                salercode:'',//销售方
                salername: '', // 销售方名称
                supplyername: '', // 供应商名称
                memo:'',//采购说明
            },
            payRecordList:[],
            tradingRoleDlog:false,//追加采购商品显隐
            tradingRoleForm:{//追加采购商品
                invgoodsname:'',//产品名称
                invkindinfo:'',//规格型号
                unit:'',//单位
                unitprice:'',//单价
                taxrate:'',//税率
                num:'',//数量
                // status:true,//状态
                memo:'',//备注
            },
            tradingRoleRule:{
                invgoodsname: [{ required: true, message: "产品名称不能为空！", trigger: "blur" }],
                invkindinfo: [{ required: true, message: "规格型号不能为空！",trigger: "blur"}],
                unit: [{ required: true, message: "单位不能为空！",trigger: "blur"}],
                unitprice: [{ required: true, message: "单价不能为空！",trigger: "blur" }],
                taxrate: [{ required: true, message: "税率不能为空！",trigger: "blur" }],
                num: [{ required: true, message: "数量不能为空！",trigger: "blur" }],
            },
            checkRule: {
                supplyername: [{ required: true, message: "供应商名称不能为空！", trigger: "blur" }],
                salercode: [{ required: true, message: "请选择销售方！", trigger: "blur" }],
            },
            tradingRoleIndex: -1, // 选中编辑的商品下标
            operate:'',//操作类型
            totalAmount: 0,//总金额
            isEditMoney:false,//是否编辑采购总金额
            oldAmount: 0, // 修改过渡金额
            purcode: '', // 采购编号
            saleShow: true, // 销售方下拉组件显示
            totalDiscountPrice: 0, // 加入的采购商品总金额
        }	 
    },
    filters: {

    },
    components: {
        BuyerAndSellerSelecr: resolve => require(["@/components/InvoiceManage/BuyerAndSellerSelecr.vue"], resolve),//选择购买方/销售方下拉组件
    },
    watch:{
        'tradingRoleForm.unitprice'(val) {
            this.tradingRoleForm.unitprice = this.amountChech(val);
        },
        'tradingRoleForm.taxrate'(val) {
            this.tradingRoleForm.taxrate = this.integerCheck(val);
        },
        'tradingRoleForm.num'(val) {
            this.tradingRoleForm.num = this.integerCheck(val);
        },
        'totalAmount'(val) {
            this.totalAmount = this.amountChech(val);
        },
    },
    methods: {
        // 去除输入框最后的空格
        checkNames(type) {
            if(type == 0) {
                this.tradingRoleForm.invgoodsname = this.tradingRoleForm.invgoodsname.replace(/(^\s*)|(\s*$)/g, ""); 
            } else if(type == 1) {
                this.tradingRoleForm.invkindinfo = this.tradingRoleForm.invkindinfo.replace(/(^\s*)|(\s*$)/g, ""); 
            } else {
                this.tradingRoleForm.unit = this.tradingRoleForm.unit.replace(/(^\s*)|(\s*$)/g, ""); 
            }
        },
        // 修改总售价确定/取消
        subEditMoney(type) {
            if(type==0) {
                this.totalAmount = this.oldAmount;
            } else {
                // let priceNum = 1;
                // if(Number(this.totalDiscountPrice)>1000) {
                //     priceNum = Math.ceil(Number(this.totalDiscountPrice)/1000);
                // }
                // if(Math.abs(Number(this.totalAmount>0?this.totalAmount:0)*100 - Number(this.totalDiscountPrice)*100) > (100*priceNum)){
                //     this.totalAmount = this.oldAmount;
                //     MessageBox.alert(`当前修改金额超出可调控区间范围，总金额调整区间范围为±<i class='orangeColor'>￥${priceNum}</i>`, '系统提示', {
                //         confirmButtonText: '确定',
                //         type:'warning',
                //         dangerouslyUseHTMLString:true,
                //     });
                // }
            }
            this.isEditMoney = false;
        },
        // 获取到的销售方编号
        invoiceObtain(val) {
            this.checkForm.salercode = val.infocode;
            this.checkForm.salername = val.name;
        },
        // 打开追加采购商品弹窗
        getShowDlog(operate,row,index){
            this.operate = operate;
            if(operate == 'edit'){
                this.tradingRoleForm = {
                    invgoodsname: row.invgoodsname,//产品名称
                    invkindinfo: row.invkindinfo,//规格型号
                    unit: row.unit,//单位
                    unitprice: row.unitprice,//单价
                    taxrate: row.taxrate,//税率
                    num: row.num,//数量
                    // status:true,//状态
                    memo: row.memo,//备注
                }
                this.tradingRoleIndex = index;
            } else {
                this.tradingRoleIndex = -1;
            }
            this.tradingRoleDlog = true;
            setTimeout(() => {
                this.$refs.tradingRoleForm.clearValidate();
            }, 300);
        },
        // 关闭追加采购商品弹窗
        getCloseDlog(type){
            if(type == 1) {
                if(this.tradingRoleForm.invgoodsname==='') {
                    this.$message({
                        type: 'error',
                        message: '产品名称不能为空!',
                        offset: 200
                    })
                    return false;
                }
                if(this.tradingRoleForm.invkindinfo==='') {
                    this.$message({
                        type: 'error',
                        message: '规格型号不能为空!',
                        offset: 200
                    })
                    return false;
                }
                if(this.tradingRoleForm.unit==='') {
                    this.$message({
                        type: 'error',
                        message: '单位不能为空!',
                        offset: 200
                    })
                    return false;
                }
                if(!this.tradingRoleForm.unitprice) {
                    this.$message({
                        type: 'error',
                        message: '单价不能小于0!',
                        offset: 200
                    })
                    return false;
                }
                if(this.payRecordList.length > 0) {
                    let  testName = [];
                    this.payRecordList.forEach((item,index) => {
                        if(this.tradingRoleIndex != index) {
                            testName.push(item.invgoodsname + item.invkindinfo + item.unit);
                            // testName = testName + ',' + item.invgoodsname + item.invkindinfo + item.unit;
                        }
                    })
                    let stringName = this.tradingRoleForm.invgoodsname + this.tradingRoleForm.invkindinfo + this.tradingRoleForm.unit;
                    if(testName.indexOf(stringName) !=-1) {
                        this.$message({
                        type: 'error',
                        message: '同一次录入，不能录入相同的【产品名称+规格型号+单位】！',
                        offset: 200
                    })
                    return false;
                    }
                }
                if(this.tradingRoleForm.taxrate==='') {
                    this.$message({
                        type: 'error',
                        message: '税率不能小于0!',
                        offset: 200
                    })
                    return false;
                }
                if(this.tradingRoleForm.num==='') {
                    this.$message({
                        type: 'error',
                        message: '数量不能小于0!',
                        offset: 200
                    })
                    return false;
                }
                if(this.tradingRoleIndex!=-1) {
                    this.keys++;
                    this.payRecordList[this.tradingRoleIndex] = this.tradingRoleForm;
                } else {
                    this.payRecordList.push(this.tradingRoleForm);
                }
                this.getTotalAmount();
            } else {
                this.tradingRoleDlog = false;
            }
            // 清空表单数据
            this.closeFormInfo()
        },
        // 清空表单数据
        closeFormInfo() {
            this.$refs.tradingRoleForm.clearValidate();
            this.tradingRoleForm = {
                invgoodsname:'',//产品名称
                invkindinfo:'',//规格型号
                unit:'',//单位
                unitprice:'',//单价
                taxrate:'',//税率
                num:'',//数量
                // status:true,//状态
                memo:'',//备注
            }
        },
        //删除提示框
        delDlog(index) {
            this.$confirm('确定删除该商品吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.payRecordList.splice(index,1);
                this.getTotalAmount();
                this.$message({
                    type: 'success',
                    message: '删除成功!',
                    offset: 200
                });
            }).catch(() => {});
        },
        // 计算总金额
        getTotalAmount(){
            this.totalAmount = 0;
            this.totalDiscountPrice = 0;
            console.log(this.payRecordList,'this.payRecordList')
            this.payRecordList.map((item,index) => {
                this.totalAmount += (item.num * item.unitprice)
            })
            this.totalDiscountPrice = this.totalAmount;
        },
        // 编辑采购总金额
        getEditMoney(){
            this.isEditMoney = !this.isEditMoney;
            if(this.isEditMoney) {
                this.oldAmount = this.totalAmount;
            }
            // if(!this.isEditMoney && this.totalAmount){
            //     MessageBox.alert("当前修改金额超出可调控区间范围，总金额调整区间范围为±<i class='orangeColor'>￥10</i>", '系统提示', {
            //         confirmButtonText: '确定',
            //         type:'warning',
            //         dangerouslyUseHTMLString:true,
            //     });
            // }
        },
        //动态获取表格高度
        getHeight() {
            let tbHeight = this.$refs.gsTable.$el.offsetTop; //顶部检索条件占据的高度
            this.tableHeight = window.innerHeight - tbHeight - 130; 
        },
        // 采购提交
        procureSubmit() {
            if(!this.checkForm.salercode) {
                this.$message({
                    type: 'error',
                    message: '请选择销售方!',
                    offset: 200
                })
                return false;
            }
            if(!this.checkForm.supplyername) {
                this.$message({
                    type: 'error',
                    message: '供应商名称不能为空！',
                    offset: 200
                })
                return false;
            }
            if(this.payRecordList.length<0) {
                this.$message({
                    type: 'error',
                    message: '请添加采购商品!',
                    offset: 200
                })
                return false;
            }
            let subParams = {
                salername: this.checkForm.salername,
                salercode: this.checkForm.salercode,
                supplyername: this.checkForm.supplyername,
                purinstructions: this.checkForm.memo,
                goodsarry: this.payRecordList,
                totalamount: Number(this.totalAmount),
            }
            if(this.purcode) {
                subParams.purcode = this.purcode;
            }
            api.SAVEINVGOODSPURINFO(subParams).then(res => {
                if(res.data.status == "200") {
                    this.$message({
                        type: 'success',
                        message: res.data.message,
                        offset: 200
                    })
                    this.$router.push({
                        name: '开票商品采购清单'
                    })
                } else {
                    this.$message({
                        type: 'error',
                        message: res.data.message,
                        offset: 200
                    }) 
                }
            })
        },
        // 获取开票采购基础详情
        getInvgoodspurinfoDetail() {
            api.GET_INVGOODSPURINFODETAIL({purcode: this.purcode}).then(res => {
                if(res.data.status == "200") {
                    if(res.data.data && res.data.data != 'null') {
                        let purinfoDetail = res.data.data;
                        this.checkForm = {
                            salercode: purinfoDetail.salercode,//销售方
                            salername: purinfoDetail.salername, // 销售方名称
                            supplyername: purinfoDetail.supplyername, // 供应商名称
                            memo: purinfoDetail.purinstructions,//采购说明
                        }
                        this.totalAmount = purinfoDetail.totalamount;
                        this.saleShow = true;
                    }
                } else {
                    this.saleShow = true;
                    this.$message({
                        type: 'error',
                        message: res.data.message,
                        offset: 200
                    })
                }
            }).catch(res => {
                this.saleShow = true;
            })
        },
        // 获取开票采购清单信息
        getInvgoodspurdetailList() {
            let invParams = {
                purcode: this.purcode,
                pagetype: 0,
                // pageparam: {
                //     pagesize: this.pageSize, //每页条数
                //     currentpage: this.currentPage, //当前页数
                //     isnewcomp: 1 //是否需要重新统计页数
                // }
            }
            api.GET_INVGOODSPURDETAILLIST(invParams).then(res => {
                if(res.data.status == "200") {
                    if(res.data.data && res.data.data != 'null') {
                        this.payRecordList = res.data.data;
                        this.totalDiscountPrice = 0;
                        this.payRecordList.map((item,index) => {
                            this.totalDiscountPrice += (item.num * item.unitprice)
                        })
                    }
                }
            })
        }
    },
    //============================================== 生命周期 ==============================================
    created() {
        //页面浏览器视窗变化绑定resize事件
        window.addEventListener("resize", this.getHeight);
    },
    mounted () {
        //在dom渲染之后
        setTimeout(()=>{
            this.getHeight();   
        },200);
        if(this.$route.query.purcode) {
            this.purcode = this.$route.query.purcode;
            // 获取开票采购基础详情
            this.getInvgoodspurinfoDetail();
            // 获取开票采购清单信息
            this.getInvgoodspurdetailList();
            this.saleShow = false;
        }
    },
    destroyed(){ 
        window.removeEventListener('resize', this.getHeight); //销毁监听浏览器视窗变化
    }
}
</script>
<style scoped>
.mainDet{
    position: relative;
    padding: 20px 20px 85px;
    height: calc(100% - 105px);
    overflow-y: auto;
}
.mainDet .commonTit{margin-bottom: 30px;}
.comForm>>>.el-form-item__content {
    width: 65%;
    min-width: 200px;
    max-width: 340px;
}
.comForm .el-select{width: 100%;}
.pdr70{width: auto;padding-right: 70px;}
.addMemberDlog>>>.el-dialog{
    width:1100px;
}
.addMemberDlog>>>.el-form-item__error{
    margin-left: 0;
}
.goodsWrap >>> .el-form-item__content {width:65%; min-width: 200px; max-width: 340px;}
.isChose{
  color: #999;
  margin-right: 10px;
}
.editIcon{margin-left: 5px;font-size: 15px;cursor: pointer;}
.editMoneyIpt{width: 150px;margin-left: 5px;}
.editMoneyIpt>>>.el-input__inner{color: #FA2F2F!important;font-weight: bold;}
.editMoneyIpt>>>.el-input-group__prepend{padding: 0 10px!important;}
.bottomBtn{-ms-justify-content:center;-o-justify-content:center;-moz-justify-content:center;-webkit-justify-content:center;justify-content:center}
.editBtn samp{font-family: inherit;cursor: pointer;font-size: 12px;margin-left: 5px;}
</style>



// WEBPACK FOOTER //
// src/views/InvoiceManage/PurchaseAdd.vue